"use strict";

class ConsumerContainerController {
    constructor(createAutoQuery, consumerPrompt, $state) {
        let options = {
            url: 'QueryConsumers.json?Id=' + this.consumerId,
            autoLoad: true,
            onLoaded: args => this.consumer = args.first
        };
        this.query = createAutoQuery(options);
        this.prompt = consumerPrompt;
    }
    load(){return this.query.load.apply(this.query, arguments);}
    add(){return this.prompt.add().then(args => $state.go('consumer', {id: args.id}));}
    edit(){return this.prompt.edit(this.consumer).then(() => this.query.load(true));}
    delete(){return this.prompt.delete(this.consumer).then(() =>  $state.go('consumers'));}
    changePassword(){return this.prompt.changePassword(this.consumer).then(() => $state.go('consumers'));}
    $onDestroy() {
        this.query.dispose();
    }
}

class ConsumerContainer{
    constructor(){
        this.bindings= {
            consumerId: '@'
        };
        this.controller = ConsumerContainerController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumer-container.html'
    }
}

angular.module('emun.consumer').component('consumerContainer', new ConsumerContainer());

export default  ConsumerContainer;